import {
  Col,
  Row,
  Card,
  Button, Divider, Tag
} from "antd";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  SUBSCRIPTION
} from "../../config/constants/api";
import { Put } from "../../config/api/put";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import { Get } from "../../config/api/get";
import moment from "moment";
import DashbordSidebar from "../../components/DashboardSidebar";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const EditProfile = () => {
  const [subscription, setSubscription] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [isMapVisible, setIsMapVisible] = useState(false); // State to control visibility
  const [isArriveVisible, setIsArriveVisible] = useState(false); // State to toggle buttons

  const handleStartClick = () => {
    setIsMapVisible(true); // Show map and hide steps
    setIsArriveVisible(true); // Show Arrive button
  };

  const handleArriveClick = () => {
    console.log("Arrived!"); // Add further logic if needed
  };

  const [isChatVisible, setIsChatVisible] = useState(false); // State to control chat visibility

  const toggleChat = () => {
    setIsChatVisible(!isChatVisible); // Toggle chat visibility
  };
  const getSubscription = async () => {
    Get(`${SUBSCRIPTION.getSubscription}${id}`, token)
      .then((response) => {
        if (response?.status) {
          console.log("response", response.data);
          setSubscription(response.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    getSubscription();
  }, []);
  const handleCancel = async () => {
    Put(`${SUBSCRIPTION.cancelSubscription}${id}`, token)
      .then((response) => {
        if (response?.status) {
          swal("Success", "Subscription Cancelled Successfully", "success");
          getSubscription();
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message || err?.message;
        swal("Error", message, "error");
        console.log("error", err);
      });
  };
  return (
    <div className="shop-page bg-white py-6">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="profile-information-wrapper">
                      <FaArrowLeftLong
                          className="arrow cursor-pointer"
                          onClick={() => navigate(-1)}
                        />
                        <h3 className="text-5xl max-desktop:text-4xl font-goldman text-center py-4">
                          {subscription?.plan?.title} - Details
                        </h3>
                      </div>
                      <div className="bg-parent relative">
                        <Row justify="center">
                          <Col xs={24} md={24} xl={24}>
                            <Card>
                              <div className="boxDetails">
                                <div className="text-end">
                                  {subscription?.isActive && (
                                    <Tag color="success">ACTIVE</Tag>
                                  )}
                                  {subscription?.isCancelled && (
                                    <Tag color="error">CANCELLED</Tag>
                                  )}

                                  {subscription?.isActive && (
                                    <Tag color="success">
                                      Auto-renew on{" "}
                                      {moment(subscription?.purchaseDate)
                                        .add(1, "month")
                                        .format("YYYY-MM-DD")}
                                    </Tag>
                                  )}

                                  <h4 className="font-tavi text-[20px] text-black">
                                    Remaining Monthly Hours:
                                  </h4>
                                  <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                    {subscription?.remainingHours} hours
                                  </p>
                                </div>
                                <Row
                                  justify="start"
                                  className="my-4"
                                  gutter={[16, 16]}
                                >
                                  <Col xs={24} md={24} lg={20} xxl={12}>
                                    <div className="border border-gray-300 py-4 px-4 pay-slip">
                                      <h4 className="font-tavi text-[20px] text-black">
                                        Duration
                                      </h4>
                                      <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        Paid Monthly
                                      </p>
                                      <Divider className="my-2" />
                                      <h4 className="font-tavi text-[20px] text-black">
                                        Amount Paid
                                      </h4>
                                      <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        ${subscription?.plan?.dicountedAmount}
                                        .00
                                      </p>
                                      <Divider className="my-2" />
                                      <h4 className="font-tavi text-[20px] text-black">
                                        Date of Purchase
                                      </h4>
                                      <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        {extractDate(
                                          subscription?.purchaseDate
                                        )}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col xs={24} md={24} lg={20} xxl={12}>
                                    <div className="border border-gray-300 py-4 px-4 pay-slip">
                                      <h4 className="font-tavi text-[20px] text-black">
                                        {
                                          subscription?.plan?.title.split(
                                            " "
                                          )[0]
                                        }{" "}
                                        Hours Included:
                                      </h4>
                                      <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        {subscription?.plan?.hours} hours
                                      </p>
                                      <Divider className="my-2" />
                                      <h4 className="font-tavi text-[20px] text-black">
                                        Hours Consumed till now:
                                      </h4>
                                      <p className="font-euclid text-sm  max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        {subscription?.plan?.totalHours -
                                          subscription?.remainingHours}{" "}
                                        hours
                                      </p>
                                      <Divider className="my-2" />
                                      <h4 className="font-tavi text-[20px] text-black">
                                        Each Booking Duration:
                                      </h4>
                                      <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                        {subscription?.plan?.bookingDuration}{" "}
                                        hours (one booking)
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={24}>
                                    {subscription?.isActive && (
                                      <Button
                                        onClick={handleCancel}
                                        className="web-btn text-sm max-xl:text-xs m-auto block"
                                      >
                                        Cancel Subscription
                                      </Button>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EditProfile;
